import { render, staticRenderFns } from "./authAbnormalWarnModal.vue?vue&type=template&id=087adce0&scoped=true&"
import script from "./authAbnormalWarnModal.vue?vue&type=script&lang=js&"
export * from "./authAbnormalWarnModal.vue?vue&type=script&lang=js&"
import style0 from "./authAbnormalWarnModal.vue?vue&type=style&index=0&id=087adce0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087adce0",
  null
  
)

export default component.exports